import ExtendedCardFullViewCollapsableWrapper from './ExtendedCardFullViewCollapsableWrapper';
import setCoverOriginalContent from 'owa-mail-reading-pane-store/lib/actions/setCoverOriginalContent';
import ExtendedCardViewState, {
    ExtendedCardType,
} from 'owa-mail-reading-pane-store/lib/store/schema/ExtendedCardViewState';
import getSnoozeSubMenu from '../utils/getSnoozeSubMenu';
import { observer } from 'mobx-react-lite';
import { CalendarCard, CalendarCardViewState } from 'owa-mail-calendar-card';
import { MeetingPollCard } from 'owa-mail-meetingpoll-card';
import { VotingResultsCard } from 'owa-mail-voting';
import VotingCardViewState from 'owa-mail-voting/lib/store/schema/VotingCardViewState';
import { ReadingPaneTxpHeader } from 'owa-txp';
import { YammerCard, YammerCardViewState } from 'owa-yammer-thread';
import * as React from 'react';
import TxpCardViewState from 'txp-data/lib/schema/viewSchema/TxpCardViewState';

export interface ExtendedCardWrapperProps {
    extendedCardViewState: ExtendedCardViewState;
}

const ExtendedCardWrapper: React.FunctionComponent<ExtendedCardWrapperProps> = props => {
    const { extendedCardViewState } = props;

    if (!extendedCardViewState) {
        return null;
    }

    const { cardViewState, cardType } = extendedCardViewState;

    switch (cardType) {
        case ExtendedCardType.TXP:
            return (
                <ReadingPaneTxpHeader
                    viewState={cardViewState as TxpCardViewState}
                    snoozeSubMenu={getSnoozeSubMenu}
                />
            );
        case ExtendedCardType.CalendarCard:
            return <CalendarCard viewState={cardViewState as CalendarCardViewState} />;
        case ExtendedCardType.Voting:
            return <VotingResultsCard votingCardViewState={cardViewState as VotingCardViewState} />;
        case ExtendedCardType.Yammer:
            const yammerCard = (
                <YammerCard
                    key={(cardViewState as YammerCardViewState)?.item?.ItemId?.Id}
                    isInitiallyExpanded={!!extendedCardViewState.coverOriginalContent}
                    collapseCallback={setExtendedCardCoverOriginalContent(extendedCardViewState)}
                    viewState={cardViewState as YammerCardViewState}
                />
            );

            return (
                <ExtendedCardFullViewCollapsableWrapper
                    key={(cardViewState as YammerCardViewState)?.item?.ItemId?.Id}
                    {...props}>
                    {yammerCard}
                </ExtendedCardFullViewCollapsableWrapper>
            );
        case ExtendedCardType.MeetingPoll:
            return <MeetingPollCard />;
    }

    return null;
};

function setExtendedCardCoverOriginalContent(
    extendedCardViewState: ExtendedCardViewState
): () => void {
    return () => {
        setCoverOriginalContent(extendedCardViewState, false /*shouldCover*/);
    };
}

export default observer(ExtendedCardWrapper);
